import { Button, Flex } from '@mantine/core';
import { IconArrowNarrowRight, IconArrowRight, IconArrowUpRight, IconBolt, IconCheck, IconChevronLeft, IconChevronRight, IconCirclePlus, IconDatabase, IconDeviceDesktop, IconDownload, IconExternalLink, IconEye, IconFileInvoice, IconHistory, IconPencil, IconPlus, IconRefresh, IconSearch, IconShield, IconShieldCheck, IconUpload, IconUser, IconUserShare, IconUsers, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { clickableColor, sideNavbarcolor } from '../../mantineReactTable/sizes';
import CustomTooltip from '../CustomTooltip/CustomTooltip';


interface CustomButtonProps {
	text: string;
	onClick?: () => void;
	buttonType: 'add' | 'cancel' | 'tab' | 'next' | 'Submit' | 'DisableButton' | 'BasicInfoButton' | 'managePermission' | 'highlight' | 'Issue' | 'addAllocation' | 'letsDoIt' | 'login' | 'logout' | 'userProfile' | 'addDismiss' | 'reHire' | 'reject' | 'changePassword' | 'workHour' | 'document' | 'Select' | 'footerButton' | 'monthlyApproval' | 'monthlyReject' | 'export' | 'invoice' | 'copyBtn' | 'assignmentBtn' | 'addWithIcon' | 'rollOverBtn' | 'discardBtn' | 'publishBtn' | 'journelBtn' | 'hubBtn' | 'reset' | 'launchPortalBtn' | 'complainceBtn' | 'pafLockerBtn' | 'prepareBtn' | 'sandboxBtn' | 'weblinkBtn' | 'snapshotBtn' | 'manageWorkflowBtn' | 'backToDirectoryBtn' | 'SimulateUploadRoadmapBtn' | 'advanceStageBtn' | 'returnToLiveBtn' | 'testReviewBtn' | 'retractBtn' | 'clearBtn' | 'directoryBtn' | 'stepOwnerShipBtn' | 'addComplainceStepBtn' | 'resetToDefaultBtn' | 'addCatgeoryImmigration' | 'addLinkBtn' | 'inspectionBtn' | 'unlockInspectBtn' | 'previewBtn' | 'verifySealBtn' | 'requestBtn' | 'uploadFileBtn' | 'markAsFinalBtn' | 'deliveryModeBtn' | 'historyBtn' | 'addRequirmentSetBtn' | 'publicPortalBtn' | 'addItemBtn' | 'CustomButton';
	disabled?: boolean;
	fz?: number;
	text1?: React.ReactElement | string;
	// type?:'submit';
	isvalidate?: boolean;
	variant?: string;
	fw?: number;
	p?: number | string | undefined;
	btnSize?: string;
	height?: number;
	toolTip?: string;
	iconName?: string;
	color?: string;
	borderRadius?: string | number;
	isfullWidth?: boolean;
	btnWidth?: number;
	backgroundColor?: string;
	style?: React.CSSProperties;
	textTransform?: string;
	hoverColor?: string;
	leftSection?: React.ReactElement;
	isAssetAllocation?: boolean;
	active?: boolean;
	hoverBackgroundColor?: string;
	leftSectionMarginRight?: number;
}

const CustomButton = ({ text, onClick, buttonType, btnWidth, disabled, fz, text1, active, iconName, isvalidate, variant, fw, p, btnSize, height, toolTip, color, borderRadius, isfullWidth, backgroundColor, style, hoverColor, leftSection, isAssetAllocation = false, textTransform, hoverBackgroundColor, leftSectionMarginRight }: CustomButtonProps) => {
	const stroke = 1.5
	const size = '1.2rem'
	const defaultVariant = 'subtle'
	const radius = 'xl'
	const width = 90
	const icon = iconName === 'download' ? <IconDownload size={size} stroke={stroke} /> : null;
	const [hovered, setHovered] = useState(false);
	const getButtonProps = () => {
		switch (buttonType) {
			case 'add':
				return {
					leftSection: icon || <IconPlus size={size} stroke={stroke} />,
					variant: variant || 'filled',
					color: hovered ? clickableColor : sideNavbarcolor,
					disabled: disabled
				};

			case 'workHour':
				return {
					variant: variant,
					onClick: { onClick },
					color: clickableColor,
					size: btnSize,
					p: p,
					fw: fw,
					disabled: disabled,
					style: backgroundColor ? { backgroundColor, color: 'white' } : undefined,
					// radius:"xs"
				};

			case 'document':
				return {
					variant: variant,
					onClick: { onClick },
					color: color || clickableColor,
					size: btnSize,
					p: p,
					fw: fw,
					disabled: disabled,
					w: width
				};

			case 'tab':
				return {
					variant: variant,
					onClick: { onClick },
					color: clickableColor,
					size: btnSize,
					p: p,
					fw: fw,
					disabled: disabled,
					radius: "xs",
					leftSection: iconName === 'user' ? <IconUser size={size} stroke={stroke} /> : <IconUsers size={size} stroke={stroke} />,
				};

			case 'cancel':
				return {
					variant: defaultVariant,
					color: 'rgb(148 163 184)',
					fw: 700,
					mr: 3,
				};
			case 'next':
				return {
					variant: 'filled',
					color: hovered ? clickableColor : 'black',
					disabled: disabled,

				};
			case 'Submit':
				return {
					variant: variant || 'filled',
					color: hovered ? clickableColor : 'black',
					radius: borderRadius
				};
			case 'Select':
				return {
					variant: variant || 'filled',
					color: clickableColor,
					height: height,
					radius: borderRadius
				};
			case 'reject':
				return {
					variant: 'filled',
					color: 'red',

				};
			case 'DisableButton':
				return {
					variant: 'filled',
					color: 'white',
					disabled: disabled
				};
			case 'BasicInfoButton':
				return {
					variant: 'outline',
					fz: { fz },
					color: clickableColor,
					rightSection: <IconArrowRight width={17} />,
				};
			case 'managePermission':
				return {
					variant: 'transparent',
					color: 'grey'
				}
			case 'highlight':
				return {
					leftSection: <IconPlus size={size} stroke={stroke} />,
					variant: variant || 'light',
					color: clickableColor,
				}

			case 'Issue':
				return {
					leftSection: <IconUserShare size={size} stroke={stroke} />,
					variant: defaultVariant,
					color: clickableColor,
				}

			case 'addAllocation':
				return {
					leftSection: <IconCirclePlus size="1.5rem" stroke={stroke} />,
					variant: defaultVariant,
					color: clickableColor,
				}

			case 'letsDoIt':
				return {
					rightSection: <IconChevronRight size={size} stroke={stroke} />,
					variant: 'outline',
					color: clickableColor,
					size: "xs"
				}

			case 'login':
				return {
					variant: defaultVariant,
					color: clickableColor,
				}

			case 'logout':
				return {
					variant: 'transparent',
					color: 'red',
					fw: 700
				}

			case 'changePassword':
				return {
					variant: 'transparent',
					color: clickableColor,
					fw: 700
				}

			case 'userProfile':
				return {
					leftSection: <IconUser size={size} stroke={stroke} />,
					variant: 'transparent',
					color: clickableColor,
					fw: 700,
					td: 'line-through'
				}
			case 'addDismiss':
				return {
					// leftSection: <IconCirclePlus size="1.5rem" stroke={stroke} />,
					variant: 'filled',
					color: hovered ? 'red' : 'black',
					radius: radius,
				}
			case 'reHire':
				return {
					// leftSection: <IconCirclePlus size="1.5rem" stroke={stroke} />,
					variant: 'filled',
					color: hovered ? 'green' : 'black',
					radius: radius,
				}
			case 'footerButton':
				return {
					variant: variant || 'filled',
					color: hovered ? hoverColor || clickableColor : color || 'black',
					radius: radius,
					fullWidth: true,
					height: height,
					tt: textTransform || 'uppercase' as const,
					fz: fz,
					fw: fw,
					disabled: disabled,
				}

			case 'export':
				return {
					variant: variant || 'filled',
					color: hovered ? clickableColor : color || 'black',
					radius: radius,
					fullWidth: true,
					leftSection: <IconDownload size={size} stroke={stroke} />,
					height: height,
					tt: 'uppercase' as const,
					fz: fz,
					fw: fw,
					disabled: disabled
				}

			case 'monthlyApproval':
				return {
					leftSection: <IconCheck size={size} stroke={stroke} />,
					variant: variant || 'filled',
					color: hovered ? clickableColor : sideNavbarcolor,
					disabled: disabled
				}

			case 'monthlyReject':
				return {
					leftSection: <IconX size={size} stroke={stroke} />,
					variant: variant || 'filled',
					color: hovered ? clickableColor : sideNavbarcolor,
					disabled: disabled
				}

			case 'invoice':
				return {
					leftSection: <IconFileInvoice size={size} stroke={stroke} />,
					variant: variant || 'filled',
					color: hovered ? clickableColor : sideNavbarcolor,
					disabled: disabled
				}


			case 'copyBtn':
				return {
					leftSection: iconName === 'IconDatabase' ? <IconDatabase size={size} stroke={stroke} /> : <IconShield size={size} stroke={stroke} />,
					variant: 'outline',
					color: hovered ? clickableColor : color || 'rgb(148 163 184)',
					size: "xs"
				}


			case 'addWithIcon':
				return {
					leftSection: <IconPlus size={size} stroke={stroke} />,
					variant: 'outline',
					color: hovered ? clickableColor : color || 'rgb(148 163 184)',
					size: "xs"
				}

			case 'assignmentBtn':
				return {
					rightSection: <IconChevronRight size={18} stroke={stroke} />,
					variant: 'white',
					color: hovered ? clickableColor : color || 'rgb(148 163 184)',
					size: "xs",
					fz: 11,
				}

			case 'rollOverBtn':
				return {
					leftSection: <IconRefresh size={18} stroke={stroke} />,
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#059669',
						color: '#fff',
						fontWeight: 700,
						padding: '12px 20px'
					}
				};

			case 'discardBtn':
				return {
					variant: 'outline',
					color: 'gray',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						border: '1px solid #cbd5e1',
						color: '#64748b',
						background: '#fff',
						fontWeight: 700,
						padding: '12px 20px'
					}
				};

			case 'publishBtn':
				return {
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#006fff',
						color: '#fff',
						fontWeight: 700,
						padding: '12px 20px'
					}
				};
			case 'journelBtn':
				return {
					leftSection: <IconExternalLink size={15} stroke={stroke} />,
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#4f46e5',
						color: '#fff',
						fontWeight: 700,
						padding: '6px 16px',
						fontSize: '8px',
						textTransform: 'uppercase',
						letterSpacing: '0.05em',
						minWidth: '225px',
						height: '25px'
					}
				};
			case 'hubBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#f1f5f9',
						color: '#334155',
						fontWeight: 900,
						padding: '6px 16px',
						fontSize: '8px',
						textTransform: 'uppercase',
						letterSpacing: '0.05em',
						height: '25px'
					}
				};
			case 'reset':
				return {
					leftSection: <IconRefresh size={18} stroke={stroke} />,
					variant: 'filled',
					fz: fz || 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#f1f5f9',
						color: '#334155',
						fontWeight: fw || 700,
						padding: '12px 20px',
						borderRadius: '1rem',
						gap: '6px',

					}
				};
			case 'launchPortalBtn':
				return {
					leftSection: <IconExternalLink size={18} stroke={stroke} />,
					rightSection: <IconArrowUpRight size={18} stroke={stroke} />,
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#f1f5f9',
						color: '#047857',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '1rem',
						gap: '6px',

					}
				};
			case 'weblinkBtn':
				return {
					leftSection: <IconExternalLink size={18} stroke={stroke} />,
					rightSection: <IconArrowUpRight size={18} stroke={stroke} />,
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#047857',
						color: '#fff',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '12px',
						gap: '6px',

					}
				};
			case 'complainceBtn':
				return {
					variant: 'filled',
					fz: 9,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#f0f7ff',
						color: '#005ee6',
						fontWeight: 900,
						padding: '6px 12px'
					}
				};
			case 'pafLockerBtn':
				return {
					leftSection: <IconBolt size={18} stroke={stroke} />,
					variant: 'filled',
					fz: 10,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#0f172a',
						color: '#fff',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '1rem',
						gap: '6px',

					}
				};
			case 'prepareBtn':
				return {
					variant: 'transparent',
					fz: 10,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#fff',
						color: '#005ee6',
						fontWeight: 900,
						border: 'none',
						padding: '12px'
					}
				};
			case 'sandboxBtn':
				return {
					leftSection: <IconDeviceDesktop size={18} stroke={stroke} />,
					variant: 'filled',
					fz: 10,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#fff',
						color: '#0f172a',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '12px',
						gap: '6px',

					}
				};
			case 'snapshotBtn':
				return {
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#f59e0b',
						color: '#fff',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '12px'
					}
				};
			case 'manageWorkflowBtn':
				return {
					leftSection: <IconEye size={18} stroke={stroke} />,
					variant: 'filled',
					fz: fz || 10,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#0f172a',
						color: '#fff',
						fontWeight: fw || 900,
						padding: '12px 20px',
						borderRadius: '1rem',
						gap: '6px',

					}
				};
			case 'backToDirectoryBtn':
				return {
					leftSection: <IconX size={18} stroke={stroke} />,
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#000000',
						color: '#f1f5f9',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '1rem',
						gap: '8px',
						height: '100%'
					}
				};
			case 'SimulateUploadRoadmapBtn':
				return {
					leftSection: <IconPlus size={16} />,
					variant: 'filled',
					fz: 10,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: 'transparent',
						color: '#005ee6',
						fontWeight: 900,
						padding: '0px',
						marginTop: '2px',
						gap: '4px',
						letterSpacing: '0.05em',
						height: 'auto'
					}
				}
			case 'advanceStageBtn':
				return {
					leftSection: <IconArrowNarrowRight size={16} />,
					variant: 'filled',
					fz: 11,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#ffffff1a',
						color: '#ffffff80',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '12px',
						opacity: 0.6,
						width: '100%',
					}
				};
			case 'returnToLiveBtn':
				return {
					variant: 'filled',
					fz: 12,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#d97706',
						color: '#fff',
						fontWeight: 900,
						padding: '12px 20px',
						borderRadius: '12px'
					}
				};
			case 'testReviewBtn':
				return {
					leftSection: <IconDeviceDesktop size={16} />,
					variant: 'filled',
					fz: 9,
					fullWidth: true,
					height: height,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#0f172a',
						color: '#fff',
						fontWeight: 900,
						padding: '8px 12px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
					}
				};
			case 'retractBtn':
				return {
					variant: 'filled',
					fz: 9,
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#fff1f2',
						color: '#e11d48',
						fontWeight: 900,
						padding: '8px 12px',
						borderRadius: '8px',
						letterSpacing: '0.05em'
					}
				};
			case 'clearBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#f1f5f9',
						color: '#334155',
						fontWeight: 900,
						padding: '16px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
						fontSize: '12px', height: '100%',

					}
				};
			case 'directoryBtn':
				return {
					leftSection: <IconChevronLeft size={16} color="#0f172a" />,
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#fff',
						color: '#0f172a',
						fontWeight: 900,
						padding: '8px 16px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
						fontSize: '9px', height: '100%',
						border: '1px solid #e2e8f0'
					}
				};
			case 'stepOwnerShipBtn':
				return {
					leftSection: <IconPencil size={16} color="#4f46e5" />,
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#fff',
						color: '#4f46e5',
						fontWeight: 900,
						padding: '8px 16px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
						fontSize: '10px', height: '100%',
						border: 'none'
					}
				};
			case 'addComplainceStepBtn':
				return {
					leftSection: <IconPlus size={16} color="#fff" />,
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#0f172a',
						color: '#fff',
						fontWeight: 900,
						padding: '8px 16px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
						fontSize: '10px', height: '100%',
						border: 'none'
					}
				};
			case 'resetToDefaultBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					style: {
						backgroundColor: '#fff',
						color: '#334155',
						fontWeight: 900,
						padding: '16px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
						fontSize: '10px', height: '100%',
						border: '1px solid #e2e8f0'
					}
				};
			case 'addCatgeoryImmigration':
				return {
					leftSection: <IconPlus size={16} color="#fff" />,
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					style: {
						backgroundColor: '#0f172a',
						color: '#fff',
						fontWeight: 900,
						padding: '10px 16px',
						borderRadius: '8px',
						letterSpacing: '0.05em',
						fontSize: '10px', height: 'max-content',
						border: 'none'
					}
				};
			case 'addLinkBtn':
				return {
					leftSection: <IconPlus size={16} color="#fff" />,
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					style: {
						backgroundColor: '#005ee6',
						color: '#fff',
						fontWeight: 900,
						padding: '8px 16px',
						borderRadius: '16px',
						letterSpacing: '0.05em',
						fontSize: '10px', height: 'max-content',
						border: 'none'
					}
				};
			case 'inspectionBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					style: {
						backgroundColor: active ? '#10b9811a' : '#020617',
						color: active ? '#34d399' : '#CBD5E1',
						fontWeight: 800,
						padding: '10px 16px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '9px',
						border: active ? '1px solid #10b98166' : '1px solid #D1D5DB',
						height: '50px'
					}
				};
			case 'unlockInspectBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconShieldCheck size={20} />,
					style: {
						fontWeight: 700,
						padding: '10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '12px', height: '54px',
						border: 'none',
						backgroundColor: "#10b981", color: "#020617"
					}
				};
			case 'previewBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconEye size={16} color='#020617' />,
					style: {
						backgroundColor: '#10b981',
						color: '#020617',
						fontWeight: 700,
						padding: '6px 10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '9px', height: '100%',
						border: 'none',
					}
				};
			case 'verifySealBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					style: {
						backgroundColor: '#020617',
						color: '#10b981',
						fontWeight: 700,
						padding: '6px 10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '9px', height: '100%',
						border: '1px solid #fff',
					}
				};
			case 'requestBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconSearch size={16} color='#020617' />,
					style: {
						backgroundColor: '#020617',
						color: '#fff',
						fontWeight: 700,
						padding: '6px 10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '9px', height: '42px',
						border: '1px solid #fff',
					}
				};
			case 'uploadFileBtn':
				return {
					variant: 'filled',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconUpload size={16} />,
					style: {
						backgroundColor: '#020617',
						color: '#fff',
						fontWeight: 700,
						padding: '6px 10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '12px',
						border: 'none',
					}
				};
			case 'markAsFinalBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconShieldCheck size={14} />,
					style: {
						color: '#059669',
						fontWeight: 800,
						padding: '4px 10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '8px',
						border: '1px solid #a7f3d0',
					}
				};
			case 'deliveryModeBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					style: {
						fontWeight: 700,
						padding: '10px',
						borderRadius: '12px',
						letterSpacing: '0.05em',
						fontSize: '8px',
					}
				};
			case 'historyBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconHistory size={18} />,
					style: {
						fontWeight: 900,
						borderRadius: '18px',
						letterSpacing: '0.15em', border: "1px solid #EEF2F7",
						fontSize: '9px', height: '36px', backgroundColor: '#F8FAFC', color: "#475569"
					}
				};
			case 'addRequirmentSetBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconPlus size={17} />,
					style: {
						fontWeight: 700,
						padding: '0px 17px',
						borderRadius: '18px',
						letterSpacing: '0.05em', border: "1px solid #dbe1eb",
						fontSize: '12px', height: '40px', backgroundColor: '#ffffff', color: "#263247"
					}
				};
			case 'addItemBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconPlus size={17} />,
					style: {
						fontWeight: 900,
						padding: '0px 17px',
						borderRadius: '18px',
						letterSpacing: '0.05em', border: "1px solid #5146e5",
						fontSize: '12px', height: '40px', backgroundColor: '#5146e5', color: "#ffffff",
						boxShadow: '0 2px 5px rgba(81, 70, 229, 0.12)'
					}
				};
			case 'publicPortalBtn':
				return {
					variant: 'outline',
					tt: 'uppercase' as const,
					fullWidth: true,
					leftSection: <IconEye size={14} />,
					style: {
						fontWeight: 900,
						padding: '0px 17px',
						borderRadius: '18px',
						letterSpacing: '0.05em', border: "1px solid #fff",
						fontSize: '10px', height: '40px', backgroundColor: '#fff', color: "#047857",
						boxShadow: '0 2px 5px rgba(81, 70, 229, 0.12)'
					}
				};
			case 'CustomButton':
				return {
					variant: 'outline',
					bg: hovered ? hoverBackgroundColor : backgroundColor,

				};
			default:
				return {};
		}
	};

	const buttonProps = getButtonProps();

	return (
		<Flex w={isfullWidth ? '100%' : undefined} justify={isAssetAllocation ? 'center' : 'flex-start'}>
			{toolTip ? (
				<CustomTooltip label={toolTip}>
					<Button {...buttonProps} style={style} h={height || undefined} radius={borderRadius || 12} w={btnWidth || undefined} onClick={onClick} loading={isvalidate} loaderProps={{ type: 'dots' }} disabled={disabled}
					styles={{
						section: {
							marginRight: leftSectionMarginRight,
						},
					}}>
						{text || text1}
					</Button>
				</CustomTooltip>
			) : (
				<Button onMouseEnter={() => setHovered(true)} style={style} leftSection={leftSection}
					styles={{
						section: {
							marginRight: leftSectionMarginRight,
						},
					}}
					onMouseLeave={() => setHovered(false)} {...buttonProps} radius={borderRadius || 12} h={height || undefined} onClick={onClick} loading={isvalidate} loaderProps={{ type: 'dots' }} disabled={disabled}>
					{text || text1}
				</Button>
			)}
		</Flex>
	);
};

export default CustomButton;

//here call in parent componet 
{/* <CustomButton text="Add" onClick={handleAddClick} buttonType="add" />
<CustomButton text="Cancel" onClick={handleCancelClick} buttonType="cancel" />
<CustomButton text="Next" onClick={handleNextClick} buttonType="next" /> */}
